export * from '../../components/Footnote/Footnote';
